/**
 * Product Listing View
 *
 * @author Matt Asmar <github.com/MattXXV>
 */

(function ($) {
  'use strict';

  Drupal.behaviors.initializeProductListMobile = {
    attach: (context) => {
      if (context === document) {
        initialize();
      }
    },
  };

  function initialize() {
    // Store the full text body for each listing
    const product_listing_text = [];
    // Store the mobile summary for each listing
    const product_mobile_summary = [];
    // Storing view wrap
    const listing = $('.product-list');
    // Storing each listing wrapper
    const listing_body_copy = $('.listing-summary');
    // Grabbing every 5th listing to remove right margin at full width
    const listing_nomargin = $('.product-listing:nth-child(5n)');

    let viewport = $(window).width(),
      listing_width = listing.outerWidth();

    // Storing the text summaries for all listings
    function storeListingBodyCopy() {
      listing_body_copy.each(function (i) {
        let txt = $(this).text();
        product_listing_text.push(txt);
        // trimming body text summary for mobile
        if (txt.length > 50) {
          txt = txt.slice(0, 51);
          txt = txt + '...';
          product_mobile_summary.push(txt);
        } else {
          product_mobile_summary.push(txt);
          // hiding text toggle button when full text is as short as summary
          $(listing_body_copy[i]).addClass('no-summary');
        }
      });
    }

    // Creating text accordion effect for mobile
    function mobileTextAccordion() {
      // preventing double click handlers on browser resize
      listing_body_copy.off('click');

      // click handler to show and hide summary text on mobile view
      if (viewport <= 1024) {
        listing_body_copy.on('click', function () {
          $(this).toggleClass('is-active');
          buildMobileSummaryText();
        });
      }
    }

    // Load the appropriate text summary depending on viewport width
    function buildMobileSummaryText() {
      listing_body_copy.each(function (i) {
        // if text has class "open" show full content
        $(this).hasClass('is-active')
          ? $(this).text(product_listing_text[i])
          : $(this).text(product_mobile_summary[i]);

        // remove class "open" during browser resize
        if (viewport > 1024) {
          $(this).text(product_listing_text[i]);
          listing_body_copy.removeClass('is-active');
        }
      });
    }

    // Dynamically adding margin when view container inner-width at full width
    function addDynamicMargin() {
      viewport > 1024 ? listing_nomargin.css('margin-right', '20px') : null;
      listing_width >= 1440 ? listing_nomargin.css('margin-right', 0) : null;
      viewport <= 1024 ? listing_nomargin.css('margin-right', 'auto') : null;
    }

    storeListingBodyCopy();
    buildMobileSummaryText();
    mobileTextAccordion();
    addDynamicMargin();

    // resetting data on user browser resize
    $(window).resize(function () {
      viewport = $(window).width();
      listing_width = listing.outerWidth();
      buildMobileSummaryText();
      addDynamicMargin();
      mobileTextAccordion();
    });
  }
})(jQuery);
